(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["p42-composable-slideshow"] && !Shopify.designMode) return;
  try {
    
  /*
   * Theme blocks own their settings, so initialize the parent slideshow from
   * the server-selected slide before the first carousel selection event.
   */
  const p42SyncSelectedSlideTheme = (slideshow) => {
    const selectedSlide = slideshow.querySelector('.slideshow__slide.is-selected');

    if (!selectedSlide) {
      return;
    }

    const slideStyles = getComputedStyle(selectedSlide);
    slideshow.style.setProperty(
      '--slideshow-background',
      slideStyles.getPropertyValue('--slideshow-slide-background')
    );
    slideshow.style.setProperty(
      '--slideshow-controls-background',
      slideStyles.getPropertyValue('--slideshow-slide-controls-background')
    );
    slideshow.style.setProperty(
      '--slideshow-controls-color',
      slideStyles.getPropertyValue('--slideshow-slide-controls-color')
    );
  };

  const p42InitializeSlideshowThemes = (root) => {
    root.querySelectorAll('.p42-composable-slideshow').forEach((slideshow) => {
      requestAnimationFrame(() => p42SyncSelectedSlideTheme(slideshow));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => p42InitializeSlideshowThemes(document), { once: true });
  } else {
    p42InitializeSlideshowThemes(document);
  }

  document.addEventListener('shopify:section:load', (event) => p42InitializeSlideshowThemes(event.target));

  const p42SlideshowVideoMediaFor = (target) =>
    target.closest?.('video')?.closest('.p42-composable-slideshow video-media[data-p42-video-fallback]');

  document.addEventListener(
    'playing',
    (event) => {
      const videoMedia = p42SlideshowVideoMediaFor(event.target);

      if (videoMedia) {
        videoMedia.removeAttribute('data-p42-video-error');
        videoMedia.setAttribute('data-p42-video-ready', '');
      }
    },
    true
  );

  document.addEventListener(
    'error',
    (event) => {
      const videoMedia = p42SlideshowVideoMediaFor(event.target);

      if (videoMedia) {
        videoMedia.removeAttribute('data-p42-video-ready');
        videoMedia.setAttribute('data-p42-video-error', '');
      }
    },
    true
  );

  if (Shopify.designMode) {
    document.addEventListener(
      'shopify:block:select',
      (event) => {
        const slide = event.target.closest('.p42-composable-slideshow .slideshow__slide');

        if (!slide) {
          return;
        }

        const carousel = slide.closest('slideshow-carousel');
        const slides = Array.from(carousel.querySelectorAll('.slideshow__slide'));
        const slideIndex = slides.indexOf(slide);

        if (slideIndex >= 0) {
          event.stopPropagation();
          carousel.select(slideIndex, { animate: false });
        }
      },
      true
    );
  }

  } catch(e) { console.error(e); }
})();
})();
